import React, { createContext, useContext, useEffect, useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import { api } from "@/lib/api";
import LandingPage from "@/pages/LandingPage";
import LoginPage from "@/pages/LoginPage";
import SettingsDashboard from "@/pages/SettingsDashboard";
import AuthCallback from "@/pages/AuthCallback";
import ToolsPage from "@/pages/ToolsPage";
import BreathScorePage from "@/pages/BreathScorePage";
import GuidePage from "@/pages/GuidePage";

const ContentContext = createContext(null);
export const useContent = () => useContext(ContentContext);

function App() {
    const [content, setContent] = useState(null);

    useEffect(() => {
        const lenis = new Lenis({ lerp: 0.1, smoothWheel: true });
        window.__lenis = lenis;
        let rafId;
        const raf = (time) => {
            lenis.raf(time);
            rafId = requestAnimationFrame(raf);
        };
        rafId = requestAnimationFrame(raf);
        return () => {
            cancelAnimationFrame(rafId);
            lenis.destroy();
            window.__lenis = null;
        };
    }, []);

    useEffect(() => {
        api.get("/content").then(({ data }) => setContent(data)).catch((e) => console.error("content load failed", e));
    }, []);

    useEffect(() => {
        const tagId = content?.config?.google_tag_id;
        if (!tagId || document.querySelector("script[data-sbc-gtag]")) return;
        const s = document.createElement("script");
        s.async = true;
        s.dataset.sbcGtag = "1";
        s.src = `https://www.googletagmanager.com/gtag/js?id=${tagId}`;
        document.head.appendChild(s);
        window.dataLayer = window.dataLayer || [];
        window.gtag = function () { window.dataLayer.push(arguments); };
        window.gtag("js", new Date());
        window.gtag("config", tagId);
    }, [content]);

    return (
        <div className="App">
            <ContentContext.Provider value={content}>
                <BrowserRouter>
                    <AppRouter />
                </BrowserRouter>
            </ContentContext.Provider>
            <Toaster position="bottom-center" richColors />
        </div>
    );
}

function AppRouter() {
    const location = useLocation();
    if (location.hash?.includes("session_id=")) {
        return <AuthCallback />;
    }
    return (
        <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/settings" element={<SettingsDashboard />} />
            <Route path="/tools" element={<ToolsPage />} />
            <Route path="/tools/breath-score" element={<BreathScorePage />} />
            <Route path="/guides/halitosis-science" element={<GuidePage />} />
        </Routes>
    );
}

export default App;
